import {
  ChakraHStack,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface InquiryListConflictErrorModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const modalArgs = {
  bodyStyle: {
    overflow: 'visible',
  },
  footerStyle: {
    padding: '0px',
  },
  titleStyle: {
    flex: '1 0 0',
    padding: '0px',
  },
};

const TOP_LEVEL_ID = 'inquiry-conflict-error';

const InquiryListConflictErrorModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: InquiryListConflictErrorModalProps) => {
  return (
    <ModalV2
      footerContent={
        <ChakraHStack paddingTop="6px" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}-modal__confirm`}
            leftIcon={FAIconName.arrowsRotateRegular}
            onClick={onConfirm}
          >
            Refresh table
          </FireflyButton>
        </ChakraHStack>
      }
      id={TOP_LEVEL_ID}
      isOpen={isOpen}
      onClose={onCancel}
      size="lg"
      title="It looks like someone else has made changes to this inquiry"
      {...modalArgs}
    >
      <Text id={`${TOP_LEVEL_ID}-modal__body`}>
        Please refresh the table and try again.
      </Text>
    </ModalV2>
  );
};

export default InquiryListConflictErrorModal;
